module.exports = __webpack_public_path__ + "img/13.b8823c20.png";